import React, { FC, useEffect } from 'react';
import Modal from 'antd/lib/modal/Modal';
import { Form, Input } from 'antd';
import { MainReducerState } from '../store/reducers';
import { connect } from 'react-redux';
import { FormProps } from 'antd/lib/form';
import { RouteProps } from 'react-router-dom';
import { DrawerProps } from 'antd/lib/drawer';
import { ButtonProps } from 'antd/lib/button';

const requiredRule = { required: true, message: 'Ce champ est obligatoire' };

interface SaveAsModalProps extends RouteProps {
    isVisible: boolean;
    onClose: () => void;
    onSuccess?: (payload: any) => void;
}

const SaveAsModal: FC<SaveAsModalProps> = ({
    isVisible,
    onClose,
    onSuccess,
}) => {

    const [form] = Form.useForm();

    useEffect(() => {
        if (isVisible) {
            form.resetFields();
        }
    }, [isVisible, form]);

    const onFormFinish: FormProps['onFinish'] = (values) => {
        form.validateFields().then(() => {
            if (onSuccess) { onSuccess(values); }
        });
    };

    const onDrawerClose: DrawerProps['onClose'] & ButtonProps['onClick'] = () => {
        onClose();
        form.resetFields();
    };

    return (
        <Modal
            className="select-modal"
            title={'Enregistrer comme modèle'}
            width={500}
            onCancel={onDrawerClose}
            centered
            visible={isVisible}
            destroyOnClose={true}
            okText={'Valider'}
            okButtonProps={{
                type: 'primary',
                shape: 'round',
            }}
            cancelText={'Annuler'}
            cancelButtonProps={{
                shape: 'round',
            }}
            onOk={form.submit}
        >
            <Form
                form={form}
                onFinish={onFormFinish}
                layout="vertical"
                hideRequiredMark
            >
                <Form.Item
                    name={['templateName', 'en']}
                    rules={[requiredRule]}
                >
                    <Input size="large" placeholder="Saisir un nom" />
                </Form.Item>

                <Form.Item
                    name="templateCode"
                    rules={[requiredRule]}
                >
                    <Input size="large" placeholder="Saisir un code" />
                </Form.Item>
            </Form>
        </Modal>
    );

};

const mapStateToProps = (state: MainReducerState) => ({
});

export default connect(
    mapStateToProps,
    {
    },
)(SaveAsModal);
